import Image from "next/image";

const LinxFeedback = () => (
  <div className="mt-48 pb-16 md:pb-32 md:-mt-8">
    <div className="flex justify-center items-center flex-col xl:flex-row px-4 md:pr-8 md:pl-12 xl:pr-4">
      <div className="w-full xl:w-1/2 text-center md:pl-16 fs-0 pb-4 xl:pb-0 flex justify-center">
        <video
          controls
          controlsList="true"
          src={"/assets/case-study/social-networking/linx-testimonial.mp4"}
        >
          <track kind="captions" />
        </video>
      </div>
      <div className="w-full xl:w-1/2">
        <div className="flex items-center">
          <div className="flex justify-center md:justify-end w-2/12">
            <div className="w-4/5 md:w-1/2 xl:w-1/3 mb-16 mr-4">
              <Image
                alt={"qoute"}
                src={"/assets/case-study/social-networking/qoute.webp"}
                width={36}
                height={31}
                layout="fixed"
              />
            </div>
          </div>
          <div className="w-1/2">
            <div>
              <h2 className="text-xl md:text-2xl xl:text-xl font-normal text-erie-black">
                <span className="font-josefin">Linxngo Team</span>
              </h2>
              <span className="text-lg font-thin opacity-90 text-erie-black font-josefin italic">
                Linx&Go Limited
              </span>
            </div>
          </div>
          <div className="w-4/12 text-end">
            <div className="md:pl-8 pb-8 flex justify-center">
              <Image
                alt="linx-logo"
                className="w-24 md:w-1/3"
                src={"/assets/case-study/social-networking/linx-logo.webp"}
                height={81}
                width={81}
              />
            </div>
          </div>
        </div>
        <div>
          <p className="text-base md:text-lg font-normal text-justify text-erie-black mt-4 px-16">
            <span className="font-josefin">
              Their patience and listening skills are impressive. There have
              been delays and issues from our side, which they have helped with,
              been patient with, and made us feel very safe to do our business
              only with them. The deliverables have been spot on; they have
              delivered on time and exactly how we asked; if anything, they have
              gone above and beyond.
            </span>
          </p>
        </div>
      </div>
    </div>
  </div>
);

export default LinxFeedback;
